import {useFraud0Id} from '@aboutyou/config';
import {useCookie} from '@aboutyou/storage';
import {useScript} from '@aboutyou/ui-components';
import React from 'react';

export const FraudDetection = () => {
  const fraud0Id = useFraud0Id();
  const [cookie] = useCookie({
    cookieName: 'f0',
    defaultValue: undefined,
    transformRawValue: x => x,
  });

  if (fraud0Id && cookie !== '0') {
    return <FraudDetectionScript id={fraud0Id} />;
  }

  return null;
};

const FraudDetectionScript = ({id}: {id: string}) => {
  useScript(`https://bt.fraud0.com/api/v2/fz.js?cid=${id}`, {
    async: true,
    // do not use `fraud0` as id here, because this script internally uses that as a global variable. Setting id=fraud0 will override that in global window scope
    id: 'fraud-0',
  });

  return null;
};
